/**
 * Updates whether the user has currenlty internet connectivity
 * @param {boolean} online Whether the client has an internet connection
 * @returns {Object} The redux action
 */
export const updateOnlineStatus = (online = true) => ({
  type: "UPDATE_ONLINE_STATUS",
  online
});
